export function getView(is_new_calendar_default_enabled) {
  return is_new_calendar_default_enabled ? 'New' : 'Old'
}
